import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';

import { nonemptySchema } from '@utils/schema';

export const SIGN_IN_CONFIG = {
  resolver: zodResolver(
    z.object({
      username: nonemptySchema,
      password: nonemptySchema,
    })
  ),
  defaultValues: {
    username: '',
    password: '',
  },
};
